
module.exports = function colorizeIconTemplate(iconTemplate, { color = '#ffffff', foregroundColor = '#000000' }) {
  return iconTemplate.replace(/{{color}}/g, color).replace(/{{foregroundColor}}/g, foregroundColor)
}
